import { getRenderingEngines } from '../RenderingEngine/getRenderingEngine.js';
import { viewportSupportsImageSlices, } from './viewportCapabilities.js';
export default function getViewportsWithImageURI(imageURI) {
    const renderingEngines = getRenderingEngines();
    const viewports = [];
    renderingEngines.forEach((renderingEngine) => {
        const viewportsForRenderingEngine = renderingEngine
            .getViewports()
            .filter(viewportSupportsImageSlices);
        viewportsForRenderingEngine.forEach((viewport) => {
            if (viewport.hasImageURI(imageURI)) {
                viewports.push(viewport);
            }
        });
    });
    return viewports;
}
